/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formula-based estimates don't account for muscle mass, bone density, or frame size, so athletes and people with larger frames often fall outside the calculated range while still being perfectly healthy. Use the range as a general guide alongside other measures, not a strict target.`)
};

const es_hw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las estimaciones basadas en fórmulas no tienen en cuenta la masa muscular, la densidad ósea o el tamaño del marco, por lo que los atletas y personas con marcos más grandes a menudo caen fuera del rango calculado mientras siguen siendo perfectamente saludables. Usa el rango como guía general junto con otras medidas, no como un objetivo estricto.`)
};

const de_hw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formelbasierte Schätzungen berücksichtigen nicht Muskelmasse, Knochendichte oder Körpergröße, daher fallen Athleten und Menschen mit größeren Rahmen oft außerhalb des berechneten Bereichs, während sie völlig gesund sind. Verwenden Sie den Bereich als allgemeine Anleitung zusammen mit anderen Maßnahmen, nicht als strenger Zielwert.`)
};

const nl_hw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Op formules gebaseerde schattingen houden geen rekening met spiermassa, botwicht of frame grootte, dus atleten en mensen met grotere frames vallen vaak buiten het berekende bereik terwijl zij volkomen gezond zijn. Gebruik het bereik als algemene gids naast andere maten, niet als streng doel.`)
};

const fr_hw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les estimations basées sur une formule ne tiennent pas compte de la masse musculaire, de la densité osseuse ou de la taille de la charpente, donc les athlètes et les personnes avec une charpente plus grande sortent souvent de la plage calculée tout en étant parfaitement en bonne santé. Utilisez la plage comme guide général en conjonction avec d'autres mesures, pas comme un objectif strict.`)
};

const it_hw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le stime basate su formule non tengono conto della massa muscolare, della densità ossea o della dimensione del frame, quindi gli atleti e le persone con frame più grandi spesso cadono al di fuori dell'intervallo calcolato pur essendo perfettamente sani. Usa l'intervallo come guida generale insieme ad altre misure, non come target rigoroso.`)
};

const pt_br2_hw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimativas baseadas em fórmulas não levam em conta massa muscular, densidade óssea ou tamanho de quadro, portanto atletas e pessoas com quadros maiores geralmente ficam fora da faixa calculada enquanto ainda são perfeitamente saudáveis. Use a faixa como um guia geral ao lado de outras medidas, não como um alvo rígido.`)
};

const pt_hw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimativas baseadas em fórmulas não têm em conta a massa muscular, densidade óssea ou tamanho do esqueleto, portanto atletas e pessoas com esqueletos maiores muitas vezes caem fora do intervalo calculado enquanto são perfeitamente saudáveis. Use o intervalo como guia geral juntamente com outras medidas, não como alvo rigoroso.`)
};

const ja_hw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公式ベースの推定値は、筋肉量、骨密度、またはフレームサイズを考慮していないため、アスリートと大きなフレームを持つ人々は、計算範囲外にありながら完全に健康である可能性があります。他の測定と組み合わせて範囲をガイドラインとして使用し、厳密なターゲットではなく使用します。`)
};

const zh_hw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基于公式的估算没有考虑肌肉量、骨密度或体型大小，因此运动员和体型较大的人常常会落在计算范围之外，但实际上仍然非常健康。请将该范围与其他指标一起作为大致参考，而非严格的目标。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hw_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hw_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hw_faq4_a", locale)
	if (locale === "en") return en_hw_faq4_a(inputs)
	if (locale === "es") return es_hw_faq4_a(inputs)
	if (locale === "de") return de_hw_faq4_a(inputs)
	if (locale === "nl") return nl_hw_faq4_a(inputs)
	if (locale === "fr") return fr_hw_faq4_a(inputs)
	if (locale === "it") return it_hw_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_hw_faq4_a(inputs)
	if (locale === "pt") return pt_hw_faq4_a(inputs)
	if (locale === "ja") return ja_hw_faq4_a(inputs)
	return zh_hw_faq4_a(inputs)
};